import axios from "axios";

export default {
  getMethod(store, { url, mutationType, params }) {
    params = params || {};
    return axios
      .get(url, {
        headers: { Authorization: `Token ${store.state.accessToken}` },
        params,
      })
      .then((response) => {
        if (mutationType) {
          store.commit(mutationType, response.data);
        }
        return response.data;
      })
      .catch((error) => {
        if (error) {
          return error.response;
        }
      });
  },

  authMethod(store, { url, data, mutationType }) {
    return axios
      .post(url, data)
      .then((response) => {
        if (mutationType) {
          store.commit(mutationType, response.data);
        }
        return response;
      })
      .catch((error) => {
        if (error) {
          return error.response;
        }
      });
  },

  postMethod(store, { url, data }) {
    const _data = data || "";
    return axios
      .post(url, _data, {
        headers: { Authorization: `Token ${store.state.accessToken}` },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error) {
          return error.response;
        }
      });
  },

  putMethod(store, { url, params, data, mutationType }) {
    const _params = params || "";
    const _data = data || "";
    return axios
      .put(url, _data, {
        headers: { Authorization: `Token ${store.state.accessToken}` },
        params: _params,
      })
      .then((response) => {
        if (mutationType) {
          store.commit(mutationType, response.data);
        }
        return response;
      })
      .catch((error) => {
        if (error) {
          return error.response;
        }
      });
  },

  deleteMethod(store, { url, mutationType }) {
    return axios
      .delete(url, {
        headers: { Authorization: `Token ${store.state.accessToken}` },
      })
      .then((response) => {
        if (mutationType) {
          store.commit(mutationType, response.data);
        }
        return response;
      })
      .catch((error) => {
        if (error) {
          return error.response;
        }
      });
  },

  patchMethod(store, { url, params, data }) {
    const _params = params || "";
    const _data = data || "";
    return axios
      .patch(url, _data, {
        headers: { Authorization: `Token ${store.state.accessToken}` },
        _params,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error) {
          return error.response;
        }
      });
  },
};
